import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useAvatarList = () => {
  const [avatars, setAvatars] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const { data, error } = await supabase.storage
          .from('pictures')
          .list('avatars', {
            limit: 100,
            offset: 0,
          });

        if (error) {
          console.error('Error fetching avatars:', error);
          setError(error.message);
          return;
        }

        // Filter for image files and create full paths
        const imageFiles = data
          .filter(file => 
            file.name.toLowerCase().endsWith('.png') || 
            file.name.toLowerCase().endsWith('.jpg') || 
            file.name.toLowerCase().endsWith('.jpeg') ||
            file.name.toLowerCase().endsWith('.gif') ||
            file.name.toLowerCase().endsWith('.webp')
          )
          .map(file => `avatars/${file.name}`)
          .sort(); // Sort alphabetically

        setAvatars(imageFiles);
      } catch (err) {
        console.error('Error fetching avatars:', err);
        setError('Failed to load avatars');
      } finally {
        setLoading(false);
      }
    };

    fetchAvatars();
  }, []);

  return { avatars, loading, error };
};